import React, { useContext, useEffect, useState } from 'react';

import { ProfileStateContext } from '../../context/ProfileDataContext';
import { ComponentTypes, IActivity } from '../../utils/interfaces/DbInterfaces';
import { ICompDefault } from '../../utils/interfaces/TypesInterfaces';
import MetricBox from '../MetricBox/MetricBox';
import SectionWrapper from '../SectionWrapper';

import styles from './Activity.module.scss';

const DefaultData: IActivity = {
  type: ComponentTypes.Activity,
  visible: true,
  stars: 0,
  lessonsRead: 0,
  exercisePoints: 0,
  quizPoints: 0,
  totalPoints: 0,
  challenges: 1,
};

type IActivityProps = ICompDefault;

const Activity = ({ id, className }: IActivityProps) => {
  const { activityData } = useContext(ProfileStateContext);
  const [data, setData] = useState<IActivity>(DefaultData);

  useEffect(() => {
    if (activityData) {
      setData(activityData);
    }
  }, [activityData]);

  return (
    <SectionWrapper id={id} headerText='Activity Score' className={styles.body_wrapper}>
      <MetricBox title='Lessons' value={data.lessonsRead} />
      <MetricBox title='Exercises' value={data.exercisePoints} />
      <MetricBox title='Quizzes' value={data.quizPoints} />
      <MetricBox title='Challenges' value={data.challenges || 0} />
    </SectionWrapper>
  );
};

export default Activity;
